import { useMutation } from '@apollo/client';

import LearnerObjectUpdateInterestedCareers from 'bundles/onboarding-common/queries/LearnerObjectUpdateInterestedCareers.graphql';
import type {
  LearnerObject_UpdateInterestedCareersMutation as LearnerObjectUpdateInterestedCareersMutationType,
  LearnerObject_UpdateInterestedCareersMutationVariables as LearnerObjectUpdateInterestedCareersMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerObjectUpdateInterestedCareers';
import type { SelectedRole } from 'bundles/onboarding-common/types';
import { formatInterestedCareersForLearnerObject } from 'bundles/onboarding-common/utils/userProfileUtils';

const useLearnerObjectUpdateInterestedCareers = () => {
  const [updateInterestedCareersMutation] = useMutation<
    LearnerObjectUpdateInterestedCareersMutationType,
    LearnerObjectUpdateInterestedCareersMutationVariables
  >(LearnerObjectUpdateInterestedCareers, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  const updateInterestedCareers = async (roles?: SelectedRole[]) => {
    const { occupationIds, userGeneratedOccupations } = formatInterestedCareersForLearnerObject(roles);

    const variables: LearnerObjectUpdateInterestedCareersMutationVariables = {
      input: {
        interestedCareers: {
          occupationIds,
          userGeneratedOccupations,
        },
      },
    };

    const { errors, data } = await updateInterestedCareersMutation({
      variables,
    });

    if (errors) {
      return { success: false, errors: errors.map((error) => error.message) };
    }

    if (data?.LearnerObject_UpdateInterestedCareers.__typename === 'LearnerObject_UpdateInterestedCareersResultError') {
      return {
        success: false,
        errors: [data.LearnerObject_UpdateInterestedCareers.message],
      };
    }

    return { success: true, errors: [] };
  };

  return {
    updateInterestedCareers,
  };
};

export default useLearnerObjectUpdateInterestedCareers;
